import { MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import UnemploymentRateChart from "../charts/UnemploymentRateChart";
import MetricBarChart from "../charts/MetricBarChart";
import MetricCard from "../MetricCard";

const EconomyMetrics = ({ indicators, categorizedData, geoDetails, geoTag, tab }: MetricPanelProps) => {
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("Economy data:", sortedMetrics);

    const e = sortedMetrics[0];
    const annualHHInc = indicators.find((i: any) => i.id === 1076);

    return (
        <div className="h-screen">
        <p className="text-xs text-neutral-600 mx-6 pt-2">
            Activate the <span aria-hidden="true">🛈</span> <strong>button</strong> to expand additional information about a metric.
        </p>
        <div className="mx-auto px-4 pb-8 pt-2">
            <div className="grid grid-cols-1 xxs:grid-cols-2 gap-4">
                <div className="col-span-1 xxs:col-span-2 w-full">
                    {annualHHInc && 
                        <MetricBarChart 
                            metric={annualHHInc}
                            svg={null}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            height="h-40" 
                            background="bg-white"
                            barColor="#1a3a67"
                        />
                    }
                </div>

                {e.map((metric: any) => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}   
                        svg={getSvgrMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                    />
                ))}

                <div className="col-span-1 xxs:col-span-2 w-full">
                    <UnemploymentRateChart geoDetails={geoDetails} geoTag={geoTag} svg={null} title="Current Unemployment Rate Estimate" height="h-56" lineColor="#E8E8E8"/>
                </div>
            </div>
        </div>
        </div>
    );
}

export default EconomyMetrics;